module.exports = __webpack_public_path__ + "img/82.c8c32630.png";